import { render, staticRenderFns } from "./ModalClassification.vue?vue&type=template&id=458d5914"
import script from "./ModalClassification.vue?vue&type=script&lang=js"
export * from "./ModalClassification.vue?vue&type=script&lang=js"
import style0 from "./ModalClassification.vue?vue&type=style&index=0&id=458d5914&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('458d5914')) {
      api.createRecord('458d5914', component.options)
    } else {
      api.reload('458d5914', component.options)
    }
    module.hot.accept("./ModalClassification.vue?vue&type=template&id=458d5914", function () {
      api.rerender('458d5914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/batch/ModalClassification.vue"
export default component.exports